import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-social-sign-in-button',
  standalone: true,
  imports: [],
  templateUrl: './social-sign-in-button.component.html',
  styleUrl: './social-sign-in-button.component.css'
})
export class SocialSignInButtonComponent {
  @Input() buttonText: string = '';
  @Input() iconSrc: string = '';
  @Input() iconAltText: string = '';

  @Output() buttonClick = new EventEmitter<void>();

  onClick() {
    this.buttonClick.emit();
  }
}
